import { BLUE_PIECES } from 'helpers/constants';
import { itemIDsBySpriteIndex } from 'items/all_items_meta';

export const UGC_PUBLISHED_SCORE_LEVEL_OFFSET = 1000000;
export const DEFAULT_UGC_PAR_STATS = {
  turns: 30,
  undos: 3,
  time: 300
};

export const getGradeForScore = score => {
  const numericScore = Number(score);

  if (!Number.isFinite(numericScore)) {
    return null;
  }
  if (numericScore < 2000) {
    return 'd';
  }
  if (numericScore < 3000) {
    return 'c';
  }
  if (numericScore < 4000) {
    return 'b';
  }
  return 'a';
};

export const getOnlineScoreLookupKey = (mode, levelId) => {
  if (!mode || levelId == null || levelId === '') {
    return null;
  }
  return `${mode}:${levelId}`;
};

export const getUgcPublishedScoreLevelId = versionId => {
  const numericVersionId = Number(versionId);

  if (!Number.isFinite(numericVersionId) || numericVersionId <= 0) {
    return null;
  }

  return UGC_PUBLISHED_SCORE_LEVEL_OFFSET + numericVersionId;
};

export const getUgcPublishedScoreStorageKey = versionId => {
  const numericVersionId = Number(versionId);

  if (!Number.isFinite(numericVersionId) || numericVersionId <= 0) {
    return null;
  }

  return `ugc-published-v${numericVersionId}`;
};

export const getDefaultUgcParStats = levelData => {
  const logicLayer = levelData?.lvlData?.logic || levelData?.logic || [];
  const equippedItems = levelData?.equippedItems || [];

  const startingPlayerItems = equippedItems.filter(item => {
    const tileValue = logicLayer?.[item.y]?.[item.x];
    return BLUE_PIECES.includes(tileValue);
  }).length;
  const groundPickupItems = logicLayer.reduce((count, row = []) => {
    return (
      count +
      row.filter(tileValue => itemIDsBySpriteIndex[tileValue] != null).length
    );
  }, 0);

  return {
    ...DEFAULT_UGC_PAR_STATS,
    items: startingPlayerItems + groundPickupItems,
    itemScoreMax: startingPlayerItems
  };
};

export const isScoreAttemptBetter = (nextAttempt, currentAttempt) => {
  if (!nextAttempt) {
    return false;
  }
  if (!currentAttempt) {
    return true;
  }

  const nextScore = Number(nextAttempt.score) || 0;
  const currentScore = Number(currentAttempt.score) || 0;

  if (nextScore !== currentScore) {
    return nextScore > currentScore;
  }

  const nextTime = Number(nextAttempt.time);
  const currentTime = Number(currentAttempt.time);

  if (Number.isFinite(nextTime) && Number.isFinite(currentTime)) {
    return nextTime < currentTime;
  }

  return false;
};
